import React from "react";
import { Box, type BoxProps } from "@chakra-ui/react";

export const defaultAngleToBottom = "200deg";
export const defaultAngleToTop = "345deg";

type GradientCardProps = BoxProps & {
  variant: "green" | "blue";

  /** A valid `angle` or `side-or-corner` CSS property for the gradient.
   * [MDN Docs](https://developer.mozilla.org/en-US/docs/Web/CSS/gradient/linear-gradient#values) */
  angle?: string;

  /** Percentage value for the color-stop of the starting color.
   * [MDN Docs](https://developer.mozilla.org/en-US/docs/Web/CSS/gradient/linear-gradient#linear-color-stop) */
  startColorStop?: string;

  /** Percentage value for the color-stop of the ending color.
   * [MDN Docs](https://developer.mozilla.org/en-US/docs/Web/CSS/gradient/linear-gradient#linear-color-stop) */
  endColorStop?: string;
};

/**
 * Basic card component with a linear gradient background.
 */
export const GradientCard = React.forwardRef<HTMLDivElement, GradientCardProps>(
  (
    { variant, angle = defaultAngleToBottom, startColorStop = "-100%", endColorStop = "120%", children, ...props },
    ref,
  ) => {
    let baseColor;
    let endColor;

    switch (variant) {
      case "blue": {
        baseColor = "cyan";
        endColor = "blue.100";
        break;
      }

      case "green": {
        baseColor = "mint";
        endColor = "green.100";
        break;
      }

      // No default
    }

    return (
      <Box
        ref={ref}
        bgGradient={`linear(${angle}, ${baseColor} ${startColorStop}, ${endColor} ${endColorStop})`}
        border="1px"
        borderColor={baseColor}
        borderRadius="xl"
        pos="relative"
        {...props}
      >
        {children}
      </Box>
    );
  },
);
